module.exports = __webpack_public_path__ + "img/iphone.64486584.png";